<template>
  <PostList
    :entity-id="topicId"
    :total-posts-count="totalPostsCount"
    :can-create-posts="canCreatePosts"
    :view-context="viewContext"
    @optimistic-posts-count="emitOptimisticPostsCount"
    :load-posts="loadTopicPosts"
    :perform-create-post="performCreatePost"
    :perform-update-post="performUpdatePost"
    :perform-delete-post="performDeletePost"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { ViewContext } from "concerns/useContextName"
import PostList, {
  CreatePostOfEntityFunction,
  DeletePostOfEntityFunction,
  UpdatePostOfEntityFunction,
} from "features/posts/PostList.vue"
import { postsApi, topicsApi } from "store/api"
import { ResponseError } from "interfaces/error.interface"
import { LoadMoreFunction } from "features/posts/PostOmissionLoader.vue"

export default defineComponent({
  name: "TopicPostList",
  components: { PostList },
  props: {
    totalPostsCount: { type: Number, required: true },
    topicId: { type: Number, required: true },
    canCreatePosts: { type: Boolean, default: false },
    viewContext: { type: Object as PropType<ViewContext> },
  },
  computed: {},
  methods: {
    emitOptimisticPostsCount(optimisticPostsCount: number) {
      this.$emit("optimistic-posts-count", optimisticPostsCount)
    },
  },
  setup(props) {
    const performCreatePost: CreatePostOfEntityFunction = async (
      topicId: number,
      postText: string
    ) => {
      try {
        const { data } = await topicsApi.createTopicPost(topicId.toString(), {
          text: postText,
        })
        return data
      } catch (error: ResponseError) {
        console.error(error)
        return null
      }
    }

    const performUpdatePost: UpdatePostOfEntityFunction = async (
      topicId: number,
      postId: number,
      postText: string
    ) => {
      try {
        const { data } = await postsApi.updateTopicPost(
          topicId.toString(),
          postId.toString(),
          {
            text: postText,
          }
        )
        return data
      } catch (error: ResponseError) {
        console.error(error)
        return null
      }
    }

    const performDeletePost: DeletePostOfEntityFunction = async (
      topicId: number,
      postId: number
    ) => {
      try {
        await postsApi.deleteTopicPost(topicId.toString(), postId.toString())
        return true
      } catch (error: ResponseError) {
        console.error(error)
        return false
      }
    }

    const loadTopicPosts: LoadMoreFunction = (offset: number, limit: number) =>
      topicsApi
        .getTopicPosts(props.topicId.toString(), offset, limit, "asc")
        .then((response) => response.data)

    return {
      performCreatePost,
      performUpdatePost,
      performDeletePost,
      loadTopicPosts,
    }
  },
})
</script>
